var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 62,
    viewBox: "0 0 65 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9934 59.1175C26.7189 59.1175 28.1176 57.7188 28.1176 55.9933C28.1176 54.2679 26.7189 52.8691 24.9934 52.8691C23.268 52.8691 21.8693 54.2679 21.8693 55.9933C21.8693 57.7188 23.268 59.1175 24.9934 59.1175Z",
    stroke: "#7647EE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.987 59.1175C51.7124 59.1175 53.1112 57.7188 53.1112 55.9933C53.1112 54.2679 51.7124 52.8691 49.987 52.8691C48.2615 52.8691 46.8628 54.2679 46.8628 55.9933C46.8628 57.7188 48.2615 59.1175 49.987 59.1175Z",
    stroke: "#7647EE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.8823L10.9346 2.88232C10.9346 2.88232 12.2247 8.59468 13.0514 12.2549C14.7031 19.5686 16.9717 29.6135 18.3026 35.5066C18.946 38.3553 21.4756 40.3725 24.3961 40.3725H51.2232C54.1518 40.3725 56.6874 38.3384 57.3225 35.4798L62.4837 12.2549",
    stroke: "#7647EE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4837 12.2549H14.0588",
    stroke: "#7647EE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 19.2158H33V32.5492H36.3333V19.2158Z",
    stroke: "#FD561F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19.2158H39.6666V32.5492H43V19.2158Z",
    stroke: "#FD561F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.e5b6be9de93dfe1de3f9820bda3960dc.svg";
export { ForwardRef as ReactComponent };